// extracted by mini-css-extract-plugin
export default {"copyright":"r2M8Kv"};